import { render } from "./nft-ranking.vue?vue&type=template&id=9aa63834"
import script from "./nft-ranking.vue?vue&type=script&lang=js"
export * from "./nft-ranking.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__